import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const C = { bg: '#0E1520', surface: '#16202E', coral: '#E07A5F', gold: '#C4A87A', text: '#F8F9FA', border: 'rgba(255,255,255,0.08)' };
const editorial = { fontFamily: "'Cormorant Garamond', Georgia, serif" };
const sans      = { fontFamily: "'Outfit', system-ui, sans-serif" };

const FEATURES = [
  { free: '10 matches',         paid: 'Unlimited matches'          },
  { free: '1 "Just right"',     paid: 'Unlimited "Just right"'     },
  { free: 'No saving',          paid: 'Save unlimited homes'       },
  { free: 'No sharing',         paid: 'Share with anyone'          },
  { free: 'Basic match scores', paid: 'Deep match insights'        },
  { free: '–',                  paid: 'Connect with agents'        },
];

export default function UpgradePage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-20" style={{ background: C.bg }}>
      <div className="w-full max-w-lg">

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <p className="text-xs font-bold uppercase tracking-widest mb-3 text-center"
            style={{ ...sans, color: 'rgba(196,168,122,0.6)' }}>
            Goldielocks Premium
          </p>
          <h1 className="text-center mb-3 leading-none"
            style={{ ...editorial, color: C.text, fontSize: 'clamp(2.6rem,6vw,4rem)', fontWeight: 600, letterSpacing: '-0.025em' }}>
            Find the one<br />
            <span style={{ color: C.gold, fontStyle: 'italic' }}>without losing it.</span>
          </h1>
          <p className="text-center mb-10 text-sm"
            style={{ ...sans, color: 'rgba(200,211,223,0.5)', lineHeight: 1.8 }}>
            Save your matches. Come back to them.<br />Share the ones that feel right.
          </p>
        </motion.div>

        {/* Comparison */}
        <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2, duration: 0.6 }}
          className="rounded-2xl overflow-hidden mb-6"
          style={{ border: '1px solid ' + C.border }}>
          <div className="grid grid-cols-2">
            <div className="px-5 py-3 text-xs font-bold uppercase tracking-wider text-center"
              style={{ ...sans, color: 'rgba(200,211,223,0.35)', background: 'rgba(255,255,255,0.02)', borderRight: '1px solid ' + C.border }}>
              Free
            </div>
            <div className="px-5 py-3 text-xs font-bold uppercase tracking-wider text-center"
              style={{ ...sans, color: C.gold, background: 'rgba(196,168,122,0.06)' }}>
              Premium
            </div>
          </div>
          {FEATURES.map((f, i) => (
            <div key={i} className="grid grid-cols-2" style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}>
              <div className="px-5 py-3 text-xs text-center"
                style={{ ...sans, color: 'rgba(200,211,223,0.35)', background: 'rgba(255,255,255,0.01)', borderRight: '1px solid ' + C.border }}>
                {f.free}
              </div>
              <div className="px-5 py-3 text-xs text-center font-medium"
                style={{ ...sans, color: 'rgba(200,211,223,0.78)', background: 'rgba(196,168,122,0.04)' }}>
                {f.paid}
              </div>
            </div>
          ))}
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35, duration: 0.6 }}>
          <button
            onClick={() => {
              localStorage.setItem('gl_premium', '1');
              window.history.back();
            }}
            className="w-full py-4 rounded-full font-semibold text-sm mb-3 transition-all hover:opacity-90"
            style={{ ...sans, background: C.coral, color: '#fff', letterSpacing: '0.02em', boxShadow: '0 4px 28px rgba(224,122,95,0.3)' }}>
            Unlock your matches
          </button>
          <p className="text-center text-xs mb-4" style={{ ...sans, color: 'rgba(200,211,223,0.3)' }}>
            One-time unlock for this demo session
          </p>
          <Link to="/discover"
            className="block text-center text-xs transition-all hover:opacity-70"
            style={{ ...sans, color: 'rgba(200,211,223,0.35)', textDecoration: 'underline', textUnderlineOffset: '4px' }}>
            Keep browsing free
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
